jQuery(document).ready(function($) {
	function initializeCustomDropdown() {
		var $wrapper = $('.custom-select-wrapper');
		var $customSelect = $wrapper.find('.custom-select');
		var $trigger = $customSelect.find('.custom-select__trigger');
		var $options = $customSelect.find('.custom-options');
		var $selectedTime = $('.selected-time');

		// Setze den aktuellen Tag oder Fallback
		var $selectedOption = $options.find('.custom-option.selected');
		if ($selectedOption.length === 0) {
			$selectedOption = $options.find('.custom-option').first();
		}
		$trigger.find('span').text($selectedOption.text());
		$selectedTime.text($selectedOption.text());

		$trigger.on('click', function(e) {
			e.preventDefault();
			$customSelect.toggleClass('open');
		});

		$options.find('.custom-option').on('click', function() {
			if (!$(this).hasClass('selected')) {
				$(this).siblings().removeClass('selected');
				$(this).addClass('selected');
				$trigger.find('span').text($(this).text());
				$selectedTime.text($(this).text());
				$customSelect.removeClass('open');
			}
		});

		$(document).on('click', function(event) {
			if (!$wrapper.is(event.target) && $wrapper.has(event.target).length === 0) {
				$customSelect.removeClass('open');
			}
		});
	}

	initializeCustomDropdown();
});